/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Faq_2_QInputs */

const en_b2b_faq_2_q = /** @type {(inputs: B2b_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you issue 1099s or handle taxes?`)
};

const es_b2b_faq_2_q = /** @type {(inputs: B2b_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Emiten formularios 1099 o manejan impuestos?`)
};

const fr_b2b_faq_2_q = /** @type {(inputs: B2b_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Émettez-vous des formulaires 1099 ou gérez-vous les impôts ?`)
};

const de_b2b_faq_2_q = /** @type {(inputs: B2b_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellen Sie Steuerdokumente aus oder übernehmen Sie die Steuern?`)
};

const id_b2b_faq_2_q = /** @type {(inputs: B2b_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah Anda mengeluarkan dokumen pajak atau menangani pajak?`)
};

/** @type {(inputs: B2b_Faq_2_QInputs) => LocalizedString} */
const ja_b2b_faq_2_q = en_b2b_faq_2_q;

/** @type {(inputs: B2b_Faq_2_QInputs) => LocalizedString} */
const zh_b2b_faq_2_q = en_b2b_faq_2_q;

/** @type {(inputs: B2b_Faq_2_QInputs) => LocalizedString} */
const ar_b2b_faq_2_q = en_b2b_faq_2_q;

/** @type {(inputs: B2b_Faq_2_QInputs) => LocalizedString} */
const it_b2b_faq_2_q = en_b2b_faq_2_q;

/** @type {(inputs: B2b_Faq_2_QInputs) => LocalizedString} */
const ru_b2b_faq_2_q = en_b2b_faq_2_q;

/** @type {(inputs: B2b_Faq_2_QInputs) => LocalizedString} */
const pt_b2b_faq_2_q = en_b2b_faq_2_q;

/** @type {(inputs: B2b_Faq_2_QInputs) => LocalizedString} */
const ko_b2b_faq_2_q = en_b2b_faq_2_q;

/**
* | output |
* | --- |
* | "Do you issue 1099s or handle taxes?" |
*
* @param {B2b_Faq_2_QInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_faq_2_q = /** @type {((inputs?: B2b_Faq_2_QInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Faq_2_QInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_faq_2_q(inputs)
	if (locale === "es") return es_b2b_faq_2_q(inputs)
	if (locale === "fr") return fr_b2b_faq_2_q(inputs)
	if (locale === "de") return de_b2b_faq_2_q(inputs)
	if (locale === "ja") return ja_b2b_faq_2_q(inputs)
	if (locale === "zh") return zh_b2b_faq_2_q(inputs)
	if (locale === "ar") return ar_b2b_faq_2_q(inputs)
	if (locale === "id") return id_b2b_faq_2_q(inputs)
	if (locale === "it") return it_b2b_faq_2_q(inputs)
	if (locale === "ru") return ru_b2b_faq_2_q(inputs)
	if (locale === "pt") return pt_b2b_faq_2_q(inputs)
	return ko_b2b_faq_2_q(inputs)
});